import PersonIcon from '@mui/icons-material/PersonOutlineTwoTone';
import FamilyIcon from '@mui/icons-material/PeopleAltTwoTone';
import CohabitationIcon from '@mui/icons-material/GroupsTwoTone';
import FrontOfficeIcon from '@mui/icons-material/FileCopyTwoTone';
import DeleteIcon from '@mui/icons-material/PersonRemoveTwoTone';
import SystemIcon from '@mui/icons-material/SettingsTwoTone';
import RegistrationIcon from '@mui/icons-material/PersonAddAlt1TwoTone';
import MutationIcon from '@mui/icons-material/CachedTwoTone';
// import { systemRoutes } from 'system/router/routing-config';
import { SystemAuthorizationsList } from 'shell/authorizations/system';
import { PersonAuthorizationsList } from 'shell/authorizations/person';
import { FamilyAuthorizationsList } from 'shell/authorizations/family';
import { CohabitationAuthorizationsList } from 'shell/authorizations/cohabitation';
import { FrontOfficeAuthorizationsList } from 'shell/authorizations/front-office';
import { frontOfficeRoutes } from 'front-office/router/routing-config';
import NestedItemsSystem from 'shell/components/navbar/system';
import { MutationAuthorizationsList } from 'shell/authorizations/mutation';
import { CancellationsAuthorizationsList } from 'shell/authorizations/cancellations';
import { cancellationRoutes } from 'cancellations/router/routing-config';
import { SubscriptionAuthorizationsList } from 'shell/authorizations/subscription';
import { mutationRoutes } from 'mutation/router/routing-config';
import { subscriptionRoutes } from 'subscription/router/routing-config';
import {
  AutoAwesomeMotionTwoTone,
  Mail,
  MenuBookTwoTone,
  MilitaryTech,
  Upload,
} from '@mui/icons-material';
import { cohabitationRoutes } from 'cohabitation/router/routing-config';
import { CivilStatusAuthorizationsList } from 'shell/authorizations/civil-status';
import { civilStatusRoutes } from 'civil-status/router/routing-config';
import { PracticeAuthorizationsList } from 'shell/authorizations/practice';
import { practiceRoutes } from 'practice/router/routing-config';
import NestedItemsCivilStatus from 'shell/components/navbar/civil-status';
import { MassiveLoaderAuthorizationsList } from 'shell/authorizations/massive-loader';
import { MassiveLoaderMultiYearAuthorizationsList } from 'shell/authorizations/massive-loader-multi-year';
import NestedItemsPractice from 'shell/components/navbar/practice';
import { MunicipalMessengerAuthorizationsList } from 'shell/authorizations/municipal-messenger';
import { MilitaryDraftAuthorizationsList } from 'shell/authorizations/military-draft';
import NestedItemsCancellation from 'shell/components/navbar/cancellation';
import IconHistorian from 'shell/components/navbar/icon-historian';
import { HistorianAuthorizationList } from 'shell/authorizations/historian';

export const menuItems = [
  {
    link: 'persona',
    label: 'Anagrafe Nazionale',
    icon: PersonIcon,
    authorizations: PersonAuthorizationsList,
  },
  {
    link: 'storico',
    label: 'Anagrafe Comunale',
    icon: IconHistorian,
    authorizations: HistorianAuthorizationList,
  },
  {
    link: 'famiglia',
    label: 'Famiglia',
    icon: FamilyIcon,
    authorizations: FamilyAuthorizationsList,
  },
  {
    link: 'convivenza',
    label: 'Convivenza',
    icon: CohabitationIcon,
    authorizations: CohabitationAuthorizationsList,
    subItems: cohabitationRoutes[0].children
      .filter((route) => route.path && !route.hidden)
      .map((cohabRoute) => ({
        link: cohabRoute.path,
        label: cohabRoute.name || '',
        authorizations: cohabRoute.authorizations,
      })),
  },
  {
    link: '/iscrizioni',
    label: 'Iscrizioni',
    icon: RegistrationIcon,
    authorizations: SubscriptionAuthorizationsList,
    subItems: subscriptionRoutes[0].children
      .filter((route) => route.path && !route.hidden)
      .map((subscriptionRoute) => ({
        link: subscriptionRoute.path,
        label: subscriptionRoute.name || '',
        authorizations: subscriptionRoute.authorizations,
      })),
  },
  {
    link: '/mutazioni',
    label: 'Mutazioni',
    icon: MutationIcon,
    authorizations: MutationAuthorizationsList,
    subItems: mutationRoutes[0].children
      .filter((route) => route.path && !route.hidden)
      .map((mutationRoute) => ({
        link: mutationRoute.path,
        label: mutationRoute.name || '',
        authorizations: mutationRoute.authorizations,
      })),
  },
  {
    link: '/cancellazioni',
    label: 'Cancellazioni',
    icon: DeleteIcon,
    authorizations: CancellationsAuthorizationsList,
    subItems: cancellationRoutes[0].children
      .filter((route) => route.path && !route.hidden)
      .map((cancellatioRoute) => ({
        link: cancellatioRoute.path,
        label: cancellatioRoute.name || '',
        authorizations: cancellatioRoute.authorizations,
      })),
    nestedItems: NestedItemsCancellation,
  },
  {
    link: '/pratiche',
    label: 'Pratiche',
    icon: AutoAwesomeMotionTwoTone,
    authorizations: PracticeAuthorizationsList,
    subItems: practiceRoutes[0].children
      .filter((route) => route.path && !route.hidden)
      .map((practiceRoute) => ({
        link: practiceRoute.path,
        label: practiceRoute.name || '',
        authorizations: practiceRoute.authorizations,
      })),
    nestedItems: NestedItemsPractice,
  },
  {
    link: 'sportello',
    label: 'Sportello',
    icon: FrontOfficeIcon,
    authorizations: FrontOfficeAuthorizationsList,
    subItems: (frontOfficeRoutes || [])[0]?.children
      ?.filter(
        (route) =>
          (route.path && !route.hidden) || (route.path && route.hidden && route.nestedItems)
      )
      .map((route) => ({
        link: route.path,
        label: route.name || '',
        authorizations: route.authorizations,
        order: route.order,
        nestedItems: route.nestedItems,
      }))
      .sort((a, b) => (a.order && b.order && a.order > b.order ? 1 : -1)),
  },
  {
    link: '/stato-civile',
    label: 'Stato Civile',
    icon: MenuBookTwoTone,
    authorizations: CivilStatusAuthorizationsList,
    subItems: civilStatusRoutes[0].children
      .filter((route) => route.path && !route.hidden)
      .map((civilStatusRoute) => ({
        link: civilStatusRoute.path,
        label: civilStatusRoute.name || '',
        authorizations: civilStatusRoute.authorizations,
      })),
    nestedItems: NestedItemsCivilStatus,
  },
  {
    link: 'sistema',
    label: 'Sistema',
    icon: SystemIcon,
    authorizations: SystemAuthorizationsList,
    subItems: [
      {
        link: '',
        label: '',
        authorizations: undefined,
      }, // solo liste
    ],
    nestedItems: NestedItemsSystem,
    abilitations: {
      sistema: ['1', '2'],
      gestioneGeografiche: ['1', '2'],
      gestioneToponomastica: ['1', '2'],
    },
  },
  {
    link: 'caricatore-massivo',
    label: 'Caricatore Massivo',
    icon: Upload,
    authorizations: MassiveLoaderAuthorizationsList,
  },
  {
    link: 'caricatore-massivo-multi-annuale',
    label: 'Caricatore massivo Cartellini multi annuale',
    icon: Upload,
    authorizations: MassiveLoaderMultiYearAuthorizationsList,
  },
  {
    link: 'leva',
    label: 'Leva',
    icon: MilitaryTech,
    authorizations: MilitaryDraftAuthorizationsList,
  },
  {
    link: 'messi',
    label: 'Messi',
    icon: Mail,
    authorizations: MunicipalMessengerAuthorizationsList,
  },
];
